import React from 'react';

import { RouterLink } from 'app/src/components/RouterLink';

import { forTemplate } from '@trello/i18n';

const format = forTemplate('notification_supplement');

interface ButlerRuleFailedBoardData {
  application: string;
  rule: {
    url: string;
  };
}

export const ButlerRuleFailedBoardSupplement: React.FunctionComponent<ButlerRuleFailedBoardData> = ({
  application,
  rule,
}) => {
  return (
    <RouterLink href={rule.url}>
      {format('go-to-usage-log', {
        application,
      })}
    </RouterLink>
  );
};
